<template>
  <router-view/>
</template>

<style>
/* 全局样式重置 */
* {
  box-sizing: border-box;
}

#app {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-color);
  color: var(--text-primary);
}

/* 路由过渡动画 */
.router-view {
  transition: all 0.3s ease-out;
}

/* Element Plus 全局样式覆盖 */
.el-button--primary {
  background: linear-gradient(135deg, #2f54eb 0%, #597ef7 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #597ef7 0%, #2f54eb 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(47, 84, 235, 0.4) !important;
}

.el-button--primary:active {
  transform: translateY(0) !important;
}

.el-button--success {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.el-button--success:hover {
  background: linear-gradient(135deg, #85ce61 0%, #67c23a 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(103, 194, 58, 0.4) !important;
}

.el-button--warning {
  background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.el-button--warning:hover {
  background: linear-gradient(135deg, #ebb563 0%, #e6a23c 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(230, 162, 60, 0.4) !important;
}

.el-button--danger {
  background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.el-button--danger:hover {
  background: linear-gradient(135deg, #f78989 0%, #f56c6c 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 108, 108, 0.4) !important;
}

.el-button--info {
  background: linear-gradient(135deg, #909399 0%, #b1b3b8 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.el-button--info:hover {
  background: linear-gradient(135deg, #b1b3b8 0%, #909399 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(144, 147, 153, 0.4) !important;
}

/* Plain 按钮样式 */
.el-button--primary.is-plain {
  background: rgba(47, 84, 235, 0.1) !important;
  border: 1px solid #2f54eb !important;
  color: #2f54eb !important;
}

.el-button--primary.is-plain:hover {
  background: linear-gradient(135deg, #2f54eb 0%, #597ef7 100%) !important;
  border-color: transparent !important;
  color: #fff !important;
}

.el-button--success.is-plain {
  background: rgba(103, 194, 58, 0.1) !important;
  border: 1px solid #67c23a !important;
  color: #67c23a !important;
}

.el-button--success.is-plain:hover {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%) !important;
  border-color: transparent !important;
  color: #fff !important;
}

/* 禁用状态 */
.el-button.is-disabled,
.el-button.is-disabled:hover {
  background: #e4e7ed !important;
  border-color: #e4e7ed !important;
  color: #a8abb2 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* 菜单全局样式增强 */
.el-menu--horizontal {
  border-bottom: none !important;
}

.el-menu--horizontal .el-menu-item:hover {
  background-color: rgba(47, 84, 235, 0.08) !important;
  color: var(--primary-color) !important;
}

.el-menu--horizontal .el-menu-item.is-active {
  color: var(--primary-color) !important;
  border-bottom-color: var(--primary-color) !important;
}

.el-menu--horizontal .el-sub-menu:hover .el-sub-menu__title {
  background-color: rgba(47, 84, 235, 0.08) !important;
  color: var(--primary-color) !important;
}

.el-menu--horizontal .el-sub-menu.is-active .el-sub-menu__title {
  color: var(--primary-color) !important;
}

/* 下拉菜单样式增强 */
.el-popper.is-light {
  border: 1px solid rgba(47, 84, 235, 0.1) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.el-menu--popup {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.98) 100%) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 12px !important;
  position: relative !important;
  overflow: hidden !important;
}

.el-menu--popup::before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 2px !important;
  background: linear-gradient(90deg, #2f54eb 0%, #597ef7 50%, #2f54eb 100%) !important;
  background-size: 200% 100% !important;
  animation: submenuGradient 3s ease-in-out infinite !important;
}

@keyframes submenuGradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.el-menu--popup .el-menu-item {
  position: relative !important;
  overflow: hidden !important;
  font-weight: 500 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.el-menu--popup .el-menu-item::after {
  content: '' !important;
  position: absolute !important;
  left: 4px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 0 !important;
  height: 0 !important;
  border-radius: 50% !important;
  background: var(--primary-color) !important;
  transition: all 0.3s ease !important;
  opacity: 0 !important;
}

.el-menu--popup .el-menu-item:hover {
  background: linear-gradient(135deg, rgba(47, 84, 235, 0.1), rgba(89, 126, 247, 0.1)) !important;
  color: var(--primary-color) !important;
  transform: translateX(4px) !important;
  box-shadow: 0 4px 12px rgba(47, 84, 235, 0.2) !important;
  border-left: 3px solid var(--primary-color) !important;
}

.el-menu--popup .el-menu-item:hover::after {
  width: 6px !important;
  height: 6px !important;
  opacity: 1 !important;
}

.el-menu--popup .el-menu-item.is-active {
  background: linear-gradient(135deg, #2f54eb 0%, #597ef7 100%) !important;
  color: #fff !important;
  transform: translateX(4px) !important;
  box-shadow: 0 6px 16px rgba(47, 84, 235, 0.3) !important;
  border-left: 3px solid #fff !important;
  font-weight: 600 !important;
}

.el-menu--popup .el-menu-item.is-active::after {
  width: 8px !important;
  height: 8px !important;
  background: #fff !important;
  opacity: 1 !important;
}

.el-menu--popup .el-menu-item.is-active .el-icon {
  color: #fff !important;
  transform: scale(1.1) rotate(5deg) !important;
}

/* 不同菜单项的特色配色 */
.el-menu--popup .el-menu-item:nth-child(1):hover {
  border-left-color: #2f54eb !important;
  background: linear-gradient(135deg, rgba(47, 84, 235, 0.1), rgba(47, 84, 235, 0.05)) !important;
}

.el-menu--popup .el-menu-item:nth-child(2):hover {
  border-left-color: #597ef7 !important;
  background: linear-gradient(135deg, rgba(89, 126, 247, 0.1), rgba(89, 126, 247, 0.05)) !important;
}

.el-menu--popup .el-menu-item:nth-child(3):hover {
  border-left-color: #9c88ff !important;
  background: linear-gradient(135deg, rgba(156, 136, 255, 0.1), rgba(156, 136, 255, 0.05)) !important;
}

.el-menu--popup .el-menu-item:nth-child(4):hover {
  border-left-color: #2f54eb !important;
  background: linear-gradient(135deg, rgba(47, 84, 235, 0.1), rgba(47, 84, 235, 0.05)) !important;
}

/* 菜单项分隔线 */
.el-menu--popup .el-menu-item + .el-menu-item::before {
  content: '' !important;
  position: absolute !important;
  top: -1px !important;
  left: 12px !important;
  right: 12px !important;
  height: 1px !important;
  background: linear-gradient(90deg, transparent, rgba(47, 84, 235, 0.1), transparent) !important;
  z-index: 1 !important;
}

/* 表格样式增强 */
.el-table {
  border-radius: var(--radius-large) !important;
  overflow: hidden !important;
}

.el-table th.el-table__cell {
  background: #f8fafc !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
}

.el-table .el-table__row:hover {
  background: #f0f9ff !important;
}

/* 标签样式增强 */
.el-tag {
  border-radius: var(--radius-round) !important;
  font-weight: 500 !important;
  border: none !important;
}

.el-tag--success {
  background: linear-gradient(135deg, #67c23a, #85ce61) !important;
  color: #fff !important;
}

.el-tag--danger {
  background: linear-gradient(135deg, #f56c6c, #f78989) !important;
  color: #fff !important;
}

.el-tag--warning {
  background: linear-gradient(135deg, #e6a23c, #ebb563) !important;
  color: #fff !important;
}

.el-tag--info {
  background: linear-gradient(135deg, #409eff, #66b1ff) !important;
  color: #fff !important;
}

/* 输入框样式增强 */
.el-input__wrapper {
  border-radius: var(--radius-base) !important;
  transition: all 0.3s ease !important;
  border: 1px solid #e4e7ed !important;
}

.el-input__wrapper:hover {
  box-shadow: var(--shadow-light) !important;
  border-color: #c0c4cc !important;
}

.el-input__wrapper.is-focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px rgba(47, 84, 235, 0.1) !important;
}

/* 选择器样式增强 */
.el-select .el-input.is-focus .el-input__wrapper {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px rgba(47, 84, 235, 0.1) !important;
}

/* 日期选择器样式增强 */
.el-date-editor.el-input {
  border-radius: var(--radius-base) !important;
}

.el-date-editor.el-input.is-active {
  border-color: var(--primary-color) !important;
}

/* 分页器样式增强 */
.el-pagination {
  justify-content: center !important;
}

.el-pagination .el-pager li:hover {
  color: var(--primary-color) !important;
}

.el-pagination .el-pager li.is-active {
  background: var(--primary-gradient) !important;
  color: #fff !important;
  border-radius: 6px !important;
}

.el-pagination .btn-next:hover,
.el-pagination .btn-prev:hover {
  color: var(--primary-color) !important;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
